<template>
    <div>
         <b-button variant="primary" @click="modal.show = true">Edit</b-button>

        <main-dialog size="lg" title="Action" v-model="modal.show" hide-footer>
            <InputField type="text" name="notification" :label="this.$t('notification')" v-model="notification" @error="fieldError"
                :rules="{required: true, length: {min: 2, max: 128}}"
                :helpTip="{id: 'event.operation.mustache', text: this.$t('usePlaceholders')}"
            />
        </main-dialog>
    </div>
</template>

<script>
import InputField from '@/components/form/Input'
import CodeEditor from '@/components/form/Editor/HtmlCode'

export default {
    components: {
        InputField,
        CodeEditor
    },
    props: {
       value: {
         type: Object
       }
    },
    computed: {
        content: {
            get() {
                return this.value || {};
            },

            set(val) {
                this.$emit('input', val);
            }
        },

        notification: {
            get() {
                return this.content.notification || ""
            },

            set(val) {
                this.content.notification = val
            }
        }
    },
    methods: {
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        save() {
            this.modal.show = false
            this.content = {
                to: this.to,
                subject: this.subject,
                body: this.body
            }
        }
    },
    data: function() {
        return {
            errors: [],
            modal: {
                show: false
            }
        }
    },

    mounted() { }
}
</script>
